import { Box, Container, Stack, Typography } from "@mui/material";
import { HomeBg } from "assets/index";
import CheckCircleIcon from "assets/svg/CheckCirleIcon";
import { useEffect } from "react";
import { globalStyle } from "themes/global.styles";
import theme, { responsiveFontSize } from "themes/Theme";

const AboutUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.pageHeroBg}>
        <center>
          <Typography sx={styles.pageTitle}>About Us</Typography>
        </center>
      </Box>
      <Container sx={{ py: 4 }}>
        <Typography sx={globalStyle.sectionHeading}>
          Know About<span>us</span>
        </Typography>
        <Typography sx={styles.sectionHeading}>
          Merging Technology and Ecology for a Better Tomorrow
        </Typography>
        <Typography sx={styles.sectionDescription}>
          ERC Webwellet is a secure digital wallet designed exclusively for the
          Carbon Plant Project. Built on blockchain technology, it facilitates
          the storage, transfer, and management of Emission Reduction Coins
          (ERCs). With a focus on eco-conscious finance, our wallet enables
          individuals and organizations to actively participate in carbon
          emission reduction initiatives while enjoying seamless crypto
          transactions.
        </Typography>

        <Typography sx={globalStyle.sectionHeading} mt={4}>
          Why Choose<span>us</span>
        </Typography>
        <Typography sx={styles.sectionHeading}>
          Reliable Crypto Wallet for a Sustainable Future
        </Typography>
        <Stack direction={"row"} alignItems={"flex-start"} gap={1} mt={2}>
          <CheckCircleIcon />
          <Box>
            <Typography sx={styles.listHeading}>Sustainable</Typography>
            <Typography sx={styles.listDescription}>
              Supports long-term carbon reduction goals with every transaction
              made.
            </Typography>
          </Box>
        </Stack>
        <Stack direction={"row"} alignItems={"flex-start"} gap={1} mt={1}>
          <CheckCircleIcon />
          <Box>
            <Typography sx={styles.listHeading}>Secure</Typography>
            <Typography sx={styles.listDescription}>
              End-to-end encryption and blockchain immutability ensure your
              tokens remain safe and traceable.
            </Typography>
          </Box>
        </Stack>
        <Stack direction={"row"} alignItems={"flex-start"} gap={1} mt={1}>
          <CheckCircleIcon />
          <Box>
            <Typography sx={styles.listHeading}>Easy</Typography>
            <Typography sx={styles.listDescription}>
              Enjoy a clean, intuitive dashboard designed for both crypto
              beginners and experts alike.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};
export default AboutUsPage;
const styles = {
  container: {
    minHeight: "100vh",
  },
  pageHeroBg: {
    backgroundImage: `url(${HomeBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderBottomLeftRadius: "50px",
    borderBottomRightRadius: "50px",
    width: "100%",
    padding: "1em",
  },
  pageTitle: {
    py: 15,
    fontSize: responsiveFontSize(75),
    fontWeight: 400,
    color: theme.palette.custom.white,
  },
  sectionDescription: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  sectionHeading: {
    fontSize: responsiveFontSize(18),
    fontWeight: 400,
    color: theme.palette.primary.main,
    mt: 2,
    mb: 1,
  },
  listHeading: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.primary.main,
  },
  listDescription: {
    fontSize: responsiveFontSize(12),
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
};
